import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  [ORDER_FULFILLMENT_STATUSES.REJECTED]: 'Anulowane',
  [ORDER_FULFILLMENT_STATUSES.CREATED]: 'Otrzymane',
  [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: 'Potwierdzone',
  [ORDER_FULFILLMENT_STATUSES.PREPARING]: 'Przygotowywane',
  [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: 'W drodze',
  [ORDER_FULFILLMENT_STATUSES.READY]: 'Gotowe',
  status: {
    actual: 'Aktualne',
    pending: 'Oczekujące',
  },
  warning_label: {
    pickup_time_changed: '{{company}} zmieniło czas z {{initialTime}} na {{currentTime}}',
  },
  labels: {
    order_number: 'Nr zamówienia: {{number}}',
    today: 'Dzisiaj',
  },
};
